import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'scenic-home-info',
  name: '景区信息',
  icon: '介',
  group: '景区主页',
  description: '景区名称、评分、人均价、营业时间、地址与导航/电话入口。',
  defaultProps: {
    showRating: true,
    showPrice: true,
    showBusinessHours: true,
    showLocation: true
  }
}
